import * as semantic from './semantic';
import * as primitive from './primitive';
import * as component from './component';
const name = 'core';
export { primitive, semantic, component, name };
